import { CustomFileUpload } from "@hardware/Store/State/RfqRequestQuote/CustomRFQFileUploadState";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

export interface Parameter {
    file: CustomFileUpload;
}

type HandlerType = Handler<Parameter>;

export const AddFile: HandlerType = props => {
    if (!props.parameter.file) {
        return;
    }
    props.dispatch({
        type: "Custom/RFQFileUpload/AddFile",
        file: props.parameter.file,
    } as any);
};

export const ClearFiles: HandlerType = props => {
    if (props.parameter.file) {
        return;
    }
    props.dispatch({
        type: "Custom/RFQFileUpload/ClearFiles",
    } as any);
};

export const chain = [AddFile, ClearFiles];
const setRFQFileUpload = createHandlerChainRunner(chain, "RFQFileUpload");
export default setRFQFileUpload;
